// It's more representative of a real sentence to use this than to try to generate something with spaces.
const FAKE_STRING_BASE =
  '??? ??????????? ???? ?????? ??? ????????????? ????????? ?? ??????? ?? ????? ????????????? ?? ?????? ??? ?? ??????? ?? ????????? ?? ?????????? ?? ??????????? ????? ?????????? ?? ???? ???????????? ???? ????? ????????????????';

/**
 * Creates a fake string of `charCount` characters
 *
 * @param {number} charCount
 * @return {string}
 */
export function fakeString(charCount) {
  return FAKE_STRING_BASE.substring(0, charCount);
}
